import {KTSVG} from '../../../helpers'
import {AsideMenuItem} from './AsideMenuItem'
import { HOUSELINKS } from '../../../../data/constants'

export function AsideMenuMain() {
  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>CUSTOMERS</span>
        </div>
      </div>
      <AsideMenuItem
        to='/customers/person/verification'
        icon='/assets/media/icons/duotune/communication/com013.svg'
        title='Person'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/customers/company/verification'
        icon='/assets/media/icons/duotune/general/gen017.svg'
        title='Company'
        fontIcon='bi-layers'
      />

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>APPLICATIONS</span>
        </div>
      </div>
      <AsideMenuItem
        to='/onboarding/person'
        icon='/assets/media/icons/duotune/communication/com014.svg'
        title='Person'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/onboarding/company'
        icon='/assets/media/icons/duotune/ecommerce/ecm008.svg'
        title='Company'
        fontIcon='bi-layers'
      /> */}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>TOOLS</span>
        </div>
      </div>
      {/* <AsideMenuItem
        to='/bulk/requests'
        icon='/assets/media/icons/duotune/ecommerce/ecm009.svg'
        title='All Bulk Verification'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/onboarding/company'
        icon='/assets/media/icons/duotune/general/gen013.svg'
        title='Schedule Periodic Verification'
        fontIcon='bi-layers'
      /> */}
      <div className='menu-item'>
        <a href={HOUSELINKS.merchantConsole} className='menu-link without-sub' target="_blank" rel="noopener noreferrer">
          <span className="menu-icon">
            <KTSVG path='/assets/media/icons/duotune/general/gen032.svg' className='svg-icon svg-icon-2' />
          </span>
          <span className="menu-title">
            Merchant Console
          </span>
        </a>
      </div>

      <div className='menu-item'>
        <a href={HOUSELINKS.userConsole} className='menu-link without-sub' target="_blank" rel="noopener noreferrer">
          <span className="menu-icon">
            <KTSVG path='/assets/media/icons/duotune/communication/com013.svg' className='svg-icon svg-icon-2' />
          </span>
          <span className="menu-title">
            User Management
          </span>
        </a>
      </div>

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>AMENDMENTS</span>
        </div>
      </div>
      <AsideMenuItem
        to='/amendments/person'
        icon='/assets/media/icons/duotune/communication/com014.svg'
        title='Person'
        fontIcon='bi-layers'
      /> */}
      {/* <AsideMenuItem
        to='/amendments/company'
        icon='/assets/media/icons/duotune/ecommerce/ecm008.svg'
        title='Company'
        fontIcon='bi-layers'
      /> */}
    </>
  )
}
